import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import { FaEdit, FaPrint, FaRedo, FaTrash } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import Skeleton from "react-loading-skeleton";
import "./style.scss";
import DeleteUsers from "./DeleteUsers";
import EditUser from "./EditUser";
import ClearIcon from "@mui/icons-material/Clear";
import { getToken } from '../../auth/authConfig';

const skeletonStyle = {
  backgroundColor: "#f0f0f0", // Set the background color for the skeleton
  position: "relative",
  overflow: "hidden",
};

const highlighterStyle = {
  position: "absolute",
  top: 0,
  left: "-100%", // Move the highlighter off-screen initially
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 160, 0.1)", // Set the highlighter color and transparency
  animation: "highlight 5.5s infinite linear", // Add animation to create a sliding effect
};

const CBManageUser = ({userinfo}) => {
  const [userlist, setuserlist] = useState([]);
  const [loading, setloading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagelimit, setPageLimit] = useState(10);
  const componentRef_1 = useRef(null);
  const [userType, setUsertype] = useState("");
  const [query, setQuery] = useState("");
  const search_parameters = ["email"];
  const filter_by_role = [...new Set(userlist.map((item) => item.group_name))];
 
  let filteredData = [];

  filteredData = userlist.filter((obj) => {
    return obj;
  });

  function search(filteredData) {
    return filteredData.filter(
      (item) =>
        item.group_name.includes(userType) &&
        search_parameters.some((parameter) =>
          item[parameter].toString().toLowerCase().includes(query.toLowerCase())
        )
    );
  }

  const currentData = search(filteredData).slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search(filteredData).length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const getUserList = async () => {
    setloading(true);
    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/getAuditorList`;
    const token = await getToken();

    await fetch(`${url}`, {
      headers: {
        "oidc-token": token,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            console.log(json);
            setloading(false);
            setuserlist(json?.user);
          });
        }
      })
      .catch((err) => {
        setloading(false);
      });
  };

  useEffect(() => {
    getUserList();
  }, []);

  const reset = () =>{
    setCurrentPage(1)
    setQuery("")
    setUsertype("")
  }
  return (
    <div className="ManageTab">
      <div id="Create_users_id">
        <div className="wrapper">
          <div
            style={{
              display: "flex",
              paddingBottom: "0rem",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gridGap: "10px",
            }}
          >
            <div className="search-input-cont">
              <input
                type="text"
                className="table-search-input"
                placeholder="Search by email"
                value={query}
                onChange={(e) =>{ 
                  setQuery(e.target.value)
                  setCurrentPage(1)
                }}
              />
              <div className="search-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                >
                  <path
                    d="M18.0835 16.3331H17.1619L16.8352 16.0181C17.5643 15.171 18.0972 14.1733 18.3957 13.0963C18.6942 12.0193 18.7509 10.8896 18.5619 9.78806C18.0135 6.54473 15.3069 3.95473 12.0402 3.55806C10.8918 3.41277 9.7253 3.53213 8.63008 3.907C7.53485 4.28187 6.5399 4.90232 5.72135 5.72086C4.9028 6.53941 4.28236 7.53437 3.90749 8.62959C3.53261 9.72481 3.41326 10.8913 3.55855 12.0397C3.95521 15.3064 6.54521 18.0131 9.78855 18.5614C10.8901 18.7505 12.0197 18.6937 13.0968 18.3952C14.1738 18.0967 15.1715 17.5638 16.0185 16.8347L16.3335 17.1614V18.0831L21.2919 23.0414C21.7702 23.5197 22.5519 23.5197 23.0302 23.0414C23.5085 22.5631 23.5085 21.7814 23.0302 21.3031L18.0835 16.3331ZM11.0835 16.3331C8.17855 16.3331 5.83355 13.9881 5.83355 11.0831C5.83355 8.17806 8.17855 5.83306 11.0835 5.83306C13.9885 5.83306 16.3335 8.17806 16.3335 11.0831C16.3335 13.9881 13.9885 16.3331 11.0835 16.3331Z"
                    fill="#8D8D8D"
                  />
                </svg>
              </div>
              {query.trim() !== "" && (
                <ClearIcon
                  className="clear-icon"
                  onClick={() => setQuery("")}
                />
              )}
            </div>

            <div style={{ display: "flex", gridGap: "20px" }}>
              <div className="selectParent select">
                <select
                  className="custom-select"
                  aria-label="Filter by user group"
                  value={userType}
                  onChange={(e) => {
                    setUsertype(e.target.value);
                    handlePageChange({ selected: 1 });
                  }}
                >
                  <option value="">Filter by user role</option>
                  {filter_by_role.map((item, index) => (
                    <option key={index} value={item}>
                      {item === "CB Admin" ? 'CB Admin (Lead Auditor)' : item}
                    </option>
                  ))}
                </select>
                <span className="focus"></span>
              </div>

              <div>
                <Button
                  title="Reset all filters"
                  style={{
                    borderRadius: "6px",
                    textTransform: "capitalize",
                    fontSize: "16px",
                    display: "flex",
                    gridGap: "10px",
                    alignContent: "center",
                    alignItems: "center",
                    background: "#0000a0",
                    padding: "8px",
                    color: "white",
                    fontWeight: "600",
                    width: "auto",
                    height: "48px",
                  }}
                  className="submit_btn"
                  onClick={reset}
                >
                  <FaRedo />
                </Button>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingBottom: "1rem",
              paddingTop: "1rem",
            }}
          >
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                alignContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  paddingBottom: "1rem",
                  paddingTop: "1rem",
                }}
              >
                Total number of users{" "}
                <span
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#253978",
                  }}
                >
                  {search(filteredData).length}
                </span>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gridGap: "10px",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              {search(filteredData) && search(filteredData).length > 10 && (
  <div>
  <ReactPaginate
    previousLabel={"Previous"}
    nextLabel={"Next"}
    breakLabel={"..."}
    pageCount={pageCount}
    marginPagesDisplayed={2}
    pageRangeDisplayed={3}
    onPageChange={handelepageclick}
    containerClassName={"pagination"}
    pageClassName={"page-item"}
    pageLinkClassName={"page-link"}
    previousClassName={"page-item"}
    previousLinkClassName={"page-link"}
    nextClassName={"page-item"}
    nextLinkClassName={"page-link"}
    breakClassName={"page-item"}
    breakLinkClassName={"page-link"}
    activeClassName={"active"}
    forcePage={currentPage - 1}
  />
</div>
              )}
            
            </div>
          </div>

          {loading && (
            <table id="DataTable" style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "10%",
                    }}
                  >
                    Firstname
                  </th>

                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "10%",
                    }}
                  >
                    Lastname
                  </th>
                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "25%",
                    }}
                  >
                    Email
                  </th>

                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "10%",
                    }}
                  >
                    Company
                  </th>

                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "10%",
                    }}
                  >
                    Role
                  </th>

                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "20%",
                    }}
                  >
                    Created By
                  </th>
                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "15%",
                    }}
                  >
                    Last Updated On 
                  </th>

                  <th
                    className="notinPrint"
                    style={{
                      textAlign: "center",
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "5%",
                    }}
                  >
                    Actions
                  </th>
                </tr>

                {Array.from({ length: 6 }, (_, i) => (
                  <tr key={i}>
                    <td>
                      <div style={skeletonStyle}>
                        <Skeleton height={20} />
                        <div style={highlighterStyle}></div>
                      </div>
                    </td>
                    <td>
                      <div style={skeletonStyle}>
                        <Skeleton height={20} />
                        <div style={highlighterStyle}></div>
                      </div>
                    </td>

                    <td>
                      <div style={skeletonStyle}>
                        <Skeleton height={20} />
                        <div style={highlighterStyle}></div>
                      </div>
                    </td>

                    <td>
                      <div style={skeletonStyle}>
                        <Skeleton height={20} />
                        <div style={highlighterStyle}></div>
                      </div>
                    </td>

                    <td>
                      <div style={skeletonStyle}>
                        <Skeleton height={20} />
                        <div style={highlighterStyle}></div>
                      </div>
                    </td>

                    <td>
                      <div style={skeletonStyle}>
                        <Skeleton height={20} />
                        <div style={highlighterStyle}></div>
                      </div>
                    </td>

                    <td>
                      <div style={skeletonStyle}>
                        <Skeleton height={20} />
                        <div style={highlighterStyle}></div>
                      </div>
                    </td>

                    <td>
                      <div style={skeletonStyle}>
                        <Skeleton height={20} />
                        <div style={highlighterStyle}></div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {!loading && (
            <table
              id="DataTable"
              ref={componentRef_1}
              style={{ width: "100%" }}
            >
              <tbody>
                <tr>
                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "10%",
                    }}
                  >
                    Firstname
                  </th>

                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "10%",
                    }}
                  >
                    Lastname
                  </th>
                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "25%",
                    }}
                  >
                    Email
                  </th>

                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "10%",
                    }}
                  >
                    Company
                  </th>

                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "10%",
                    }}
                  >
                    Role
                  </th>

                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "20%",
                    }}
                  >
                    Created By
                  </th>
                  <th
                    style={{
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "15%",
                    }}
                  >
                    Last Updated On
                  </th>

                  <th
                    className="notinPrint"
                    style={{
                      textAlign: "center",
                      background: "#d0d8e2",
                      color: "#253978",
                      width: "5%",
                    }}
                  >
                    Actions
                  </th>
                </tr>

                {search(filteredData).length !== 0 && (
                  <>
                    {currentData.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div
                            title={item.first_name}
                            style={{
                              display: "grid",
                              justifyContent: "start",
                              fontWeight: "500",
                            }}
                          >
                            <span className="user_items_cls items_cls font-size-new">
                              {item.first_name}
                            </span>
                          </div>
                        </td>

                        <td>
                          <div
                            title={item.last_name}
                            style={{
                              display: "grid",
                              justifyContent: "start",
                              fontWeight: "500",
                            }}
                          >
                            <span className="user_items_cls items_cls font-size-new">
                              {item.last_name || "N/A"}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div
                            title={item.email}
                            style={{
                              display: "grid",
                              justifyContent: "start",
                              fontWeight: "500",
                            }}
                          >
                            <span className="user_items_cls items_cls font-size-new">
                              {item.email}
                            </span>
                          </div>
                        </td>

                        <td style={{ fontWeight: "normal" }}>
                          <span
                            style={{
                              display: "grid",
                              justifyContent: "start",
                            }}
                            title={item.company}
                          >
                            <span className="user_items_cls items_cls font-size-new">
                              {item.company}
                            </span>
                          </span>
                        </td>

                        <td style={{ fontWeight: "normal" }}>
                          <span
                            style={{
                              display: "grid",
                              justifyContent: "start",
                            }}
                            title={item.group_name}
                          >
                            <span className="user_items_cls items_cls font-size-new">
                              {item.group_name === "CB Admin" ? 'CB Admin (Lead Auditor)' : item.group_name}
                            </span>
                          </span>
                        </td>

                        <td style={{ fontWeight: "normal" }}>
                          <span
                            style={{
                              display: "grid",
                              justifyContent: "start",
                            }}
                          >
                            <span className="user_items_cls items_cls font-size-new">
                            {item.created_by}
                            </span>
                          </span>
                        </td>

                        <td style={{ fontWeight: "normal" }}>
                          <span
                            style={{
                              display: "flex",
                              gridGap: "10px",
                              flexWrap: "wrap",
                              justifyContent: "start",
                            }}
                          >
                            {item.last_updated}
                          </span>
                        </td>

                        <td
                          className="notinPrint"
                          style={{ fontWeight: "normal" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "2rem",
                              justifyContent: "center",
                              alignItems: "center",
                              alignContent: "center",
                            }}
                          >
                            <span
                                  style={{
                                    display: "grid",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  <EditUser
                                    FirstName={item.first_name}
                                    LastName={item.last_name}
                                    Role={item.group_name}
                                    email={item.email}
                                    getUserList={getUserList}
                                    id={item.user_id}
                                    group_id={item.group_id}
                                    userinfo={userinfo}
                                    Company={item.company}

                                  />
                                </span>

                            <span
                              style={{
                                display: "grid",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <DeleteUsers getUserList={getUserList} email={item.email} />
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}

                {search(filteredData).length === 0 && (
                  <tr style={{ textAlign: "center" }}>
                    <td
                      style={{ textAlign: "center", color: "red" }}
                      rowSpan={4}
                      colSpan={9}
                    >
                      No users available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default CBManageUser;
